import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '@/components/common/PageHeader';
import { DataGrid, type DataGridColumn } from '@/components/tables/DataGrid';
import { formatDateTime } from '@/utils/format';
import {
  matchingEngineLogsApi,
  type MatchingEngineActionLogRowDto,
  type MatchingEngineUploadLogRowDto,
} from '@/api/services/matchingEngineLogs';

export function MatchingEngineLogsPage() {
  const uploads = useQuery({ queryKey: ['me-logs', 'upload'], queryFn: matchingEngineLogsApi.getUploadLogs });
  const actions = useQuery({ queryKey: ['me-logs', 'action'], queryFn: matchingEngineLogsApi.getActionLogs });

  return (
    <div className="matching-engine-logs-page">
      <PageHeader title="Matching Engine Logs" breadcrumb={['Home', 'Matching Engine Logs']} />

      <div className="mb-4">
        <DataGrid
          title="Provider Upload Excel Logs"
          columns={[
            { key: 'uploadDate', title: 'Upload Date', className: 'text-start', value: (r) => r.uploadDate, cell: (r) => formatDateTime(r.uploadDate) },
            { key: 'providerName', title: 'Provider Name', className: 'text-start', value: (r) => r.providerName },
            { key: 'user', title: 'User', className: 'text-start', value: (r) => r.user },
            { key: 'description', title: 'Description', className: 'text-start', value: (r) => r.description },
          ] as DataGridColumn<MatchingEngineUploadLogRowDto>[]}
          data={uploads.data ?? []}
          rowKey={(r) => `${r.uploadDate}-${r.providerName}-${r.user}`}
          card
          columnSearch
          includeExcel
          excelFileName="Provider Upload Excel Logs"
          emptyMessage={uploads.isLoading ? 'Loading…' : 'No data.'}
        />
      </div>

      <DataGrid
        title="Matching/Unmatching/Deleting Logs"
        columns={[
          { key: 'date', title: 'Date', className: 'text-start', value: (r) => r.date, cell: (r) => formatDateTime(r.date) },
          { key: 'user', title: 'User', className: 'text-start', value: (r) => r.user },
          { key: 'action', title: 'Actions', className: 'text-start', value: (r) => r.action },
          { key: 'providerName', title: 'Provider Name', className: 'text-start', value: (r) => r.providerName },
          { key: 'ticket', title: 'Ticket', className: 'text-start', value: (r) => r.ticket },
          { key: 'statementId', title: 'Statement Id', className: 'text-start', value: (r) => r.statementId },
          { key: 'comment', title: 'Comment', className: 'text-start', value: (r) => r.comment },
        ] as DataGridColumn<MatchingEngineActionLogRowDto>[]}
        data={actions.data ?? []}
        rowKey={(r) => `${r.date}-${r.ticket}-${r.statementId}-${r.action}`}
        card
        columnSearch
        includeExcel
        excelFileName="Matching_Unmatching_Deleting Logs"
        emptyMessage={actions.isLoading ? 'Loading…' : 'No data.'}
      />
    </div>
  );
}
